import Chip, { ChipProps, Version } from '../chip/Chip';
import styles from './ChipList.module.scss';

export const ChipList = ({ chips, minChipWidth }: { chips?: Pick<ChipProps, 'label' | 'theme'>[]; minChipWidth?: ChipProps['minChipWidth']; }) => {
    return (
        <div className={styles['chip-container']}>
            {chips?.map(({ label, theme }, i) => (
                <Chip key={i} label={label} theme={theme} version={Version.minified} minChipWidth={minChipWidth} />
            ))}
        </div>
    );
};

export default ChipList;